import { Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { formatDocument, numberToCurrency } from "std/format";
import { roundAbnt } from "std/math";

const { Title } = Typography;

export const columns: ColumnType<ApiCalculo>[] = [
	{
		dataIndex: "calc_mes",
		key: "calc_mes",
		title: "Mês Ref",
	},
	{
		dataIndex: ["produtor", "for_codigoindividual"],
		key: "for_codigoindividual",
		title: "Entidade",
		render: (for_codigoindividual, record) => (
			<>
				{for_codigoindividual || ""} - {record?.produtor?.pessoa?.pes_nome_razaosocial || ""}
			</>
		),
	},
	{
		dataIndex: ["produtor", "rota", "transportador", "tra_codigoindividual"],
		key: "transportador",
		title: "Transportador",
		render: (tra_codigoindividual, record) => (
			<>
				{tra_codigoindividual || ""} - {record?.produtor?.rota?.transportador?.pessoa?.pes_nome_razaosocial || ""}
			</>
		),
	},
	{
		dataIndex: "calc_nfe_numero_doc",
		key: "calc_nfe_numero_doc",
		title: "NFE",
		align: "center",
		render: (calc_nfe_numero_doc, record) => (
			<>
				{calc_nfe_numero_doc
					? `${calc_nfe_numero_doc}/${record?.calc_nfe_serie_doc}`
					: record?.calc_nfe_chave
						? ` Chave Fiscal: ${record?.calc_nfe_chave}`
						: ""}
			</>
		),
	},
	{
		dataIndex: ["produtor", "for_banco"],
		key: "for_banco",
		title: "Banco",
	},
	{
		dataIndex: ["produtor", "pessoa", "pes_cnpj_cpf"],
		key: "pes_cnpj_cpf",
		title: "CNPJ/CPF",
		render: (pes_cnpj_cpf, row) => (
			<>
				{formatDocument(pes_cnpj_cpf || "")}
				{row?.produtor?.for_conta_documento && row?.produtor?.for_conta_documento !== pes_cnpj_cpf ? (
					<strong style={{ color: "red", marginLeft: "2px" }}> *</strong>
				) : null}
			</>
		),
	},
	{
		dataIndex: ["produtor", "for_agencia"],
		key: "for_agencia",
		title: "AG",
		render: (for_agencia, row) => (
			<>
				{for_agencia || ""}
				{row?.produtor?.for_agencia_dv ? `-${row?.produtor?.for_agencia_dv}` : ""}
			</>
		),
	},
	{
		dataIndex: ["produtor", "for_conta"],
		key: "for_conta",
		title: "CC",
		render: (for_conta, row) => (
			<>
				{for_conta || ""}
				{row?.produtor?.for_conta_dv ? `-${row?.produtor?.for_conta_dv}` : ""}
			</>
		),
	},
	{
		dataIndex: "calc_valor_total",
		key: "calc_valor_total",
		title: "Valor",
		align: "right",
		render: (value) => numberToCurrency(value || 0),
	},
];

export function TableRelPagamentoProdutor({ data, title }: { data: ApiCalculo[] | undefined; title: string }) {
	const totalValor = roundAbnt((data || []).reduce((acc, cur) => acc + cur.calc_valor_total, 0));

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Table
				rowKey="calc_idpk"
				columns={columns}
				dataSource={data}
				pagination={false}
				size="small"
				rowClassName="zebra"
				summary={(rows) => (
					<Table.Summary.Row>
						<Table.Summary.Cell index={0} colSpan={2} align="left" className={"antd-table-td-top"}>
							<div style={{ display: "flex", marginTop: "8px" }}>
								<Flex>
									<Title level={5}>
										Registros: <b>{rows?.length || 0}</b>
									</Title>
								</Flex>
							</div>
						</Table.Summary.Cell>

						<Table.Summary.Cell index={1} colSpan={7} align="right">
							<Flex className="w-full mt-3" justify={"end"}>
								<Title level={5} style={{ margin: "0px", textAlign: "right" }}>
									Total: <b>{numberToCurrency(totalValor || 0)}</b>
								</Title>
							</Flex>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				)}
			/>
		</ImpressaoContainer>
	);
}
